import { render } from "./VoicePickerModal.vue?vue&type=template&id=70ab0b95&scoped=true"
import script from "./VoicePickerModal.vue?vue&type=script&lang=js"
export * from "./VoicePickerModal.vue?vue&type=script&lang=js"

import "./VoicePickerModal.vue?vue&type=style&index=0&id=70ab0b95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ab0b95"]])

export default __exports__